import { useTranslation } from 'react-i18next';

import { Button } from 'components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from 'components/ui/dialog';
import { cn } from 'lib/utils';

interface ViewReportProps {
  open: boolean;
  onClose: () => void;
  report: string;
  contentClassName?: string;
}

export default function ViewReportDialog({
  open,
  onClose,
  report,
  contentClassName,
}: ViewReportProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className={cn('max-w-md px-4 py-6 sm:p-8', contentClassName)}
        onOpenAutoFocus={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
        hideClose
      >
        <DialogHeader>
          <DialogTitle className='text-center'>{t('scan_report')}</DialogTitle>
          <DialogDescription className='sr-only'>
            Scan report details
          </DialogDescription>
        </DialogHeader>

        <div className='mt-2 space-y-6'>
          <div className='sm:mx-12'>
            <p className='whitespace-pre-wrap'>{report}</p>
          </div>

          <div className='flex justify-center'>
            <Button onClick={onClose} className='w-24 h-8 text-sm'>
              {t('ok')}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
